var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminNavbar'),_c('div',{staticClass:"mb-6",class:{'container': _vm.hasContainer},staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }